import { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from '@mui/material';
import AssetsDialog from './AssetsDialog';
import { LeagueType } from '@/@types/api.types.ts';

const defaultState = {
  title: '',
  prize_image_en: null,
  league_type: 'CUSTOM',
} as unknown as LeagueType;

interface Props {
  league: LeagueType | null;
  open: boolean;
  onClose: () => void;
  onSuccessHandler: (league: LeagueType) => void;
}

export default function SearchDialog(props: Props) {
  const [league, setLeague] = useState<LeagueType>(defaultState);
  const [assetsTarget, setAssetsTarget] = useState(null);

  useEffect(() => {
    if (props.league !== null) {
      setLeague(props.league);
    }
  }, [props]);

  const handleChange = (e: any) => {
    const { id, value } = e.target;

    setLeague((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const onSuccess = () => {
    setLeague(defaultState);
    props.onSuccessHandler(league);
    props.onClose();
  };
  const onCancel = () => {
    setLeague(defaultState);
    props.onClose();
  };
  const onChoseAsset = (assetUrl: string) => {
    setLeague((prevState) => ({
      ...prevState,
      [String(assetsTarget)]: assetUrl,
    }));
    setAssetsTarget(null);
  };
  const onCloseAssetsDialog = () => {
    setAssetsTarget(null);
  };

  return (
    <>
      {assetsTarget === null ? (
        <Dialog
          open={props.open}
          onClose={() => {}}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            Search Friends League
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  id='title'
                  label='Title'
                  fullWidth
                  value={league.title}
                  variant='standard'
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => onCancel()}>Cancel</Button>
            <Button
              onClick={() => onSuccess()}
              autoFocus
              disabled={!league.title}
            >
              Search
            </Button>
          </DialogActions>
        </Dialog>
      ) : (
        <AssetsDialog onSuccess={onChoseAsset} onClose={onCloseAssetsDialog} />
      )}
    </>
  );
}
